import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { LoginOptions } from "./parts/login-container";
import { Loader } from "../../components/Loader";
import { STORAGE_KEY_WAITING_FOR_TOKEN } from "../../consts";
import { useAuthContext } from "../../hooks/use-auth-context";
import { selectAppJwt } from "../../store/slices/AuthSlice";
import { getSupabaseErrorMessage } from "../../util/supabase-error.utils";

const WAITING_FOR_TOKEN_KEY = STORAGE_KEY_WAITING_FOR_TOKEN;

export const LoginScreen = () => {
	const { login } = useAuthContext();
	const appJwt = useSelector(selectAppJwt);

	const isWaitingFromStorage = localStorage.getItem(WAITING_FOR_TOKEN_KEY) === "true";
	const [isWaitingForToken, setIsWaitingForToken] = useState(isWaitingFromStorage);

	const handleLoginOnSubmit = async (values: { email: string; password: string }) => {
		setIsWaitingForToken(true);
		localStorage.setItem(WAITING_FOR_TOKEN_KEY, "true");
		try {
			await login(values.email, values.password); // Keep loading state until TKA token is available
		} catch (error: unknown) {
			const errorMessage = getSupabaseErrorMessage(error);
			toast.error(`${errorMessage.summary}: ${errorMessage.detail}`);
			setIsWaitingForToken(false);
			localStorage.removeItem(WAITING_FOR_TOKEN_KEY);
		}
	};

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const hashParams = new URLSearchParams(window.location.hash.substring(1));
		const errorDescription =
			urlParams.get("error_description") || hashParams.get("error_description");
		const errorCode = urlParams.get("error") || hashParams.get("error");

		if (errorCode || errorDescription) {
			const error = {
				code: errorCode || undefined,
				message: errorDescription || errorCode || "OAuth authentication failed",
			};
			const errorMessage = getSupabaseErrorMessage(error);
			toast.error(`${errorMessage.summary}: ${errorMessage.detail}`);
			setIsWaitingForToken(false);
			localStorage.removeItem(WAITING_FOR_TOKEN_KEY);
		}
	}, []);

	useEffect(() => {
		if (isWaitingForToken && appJwt) {
			setIsWaitingForToken(false);
			localStorage.removeItem(WAITING_FOR_TOKEN_KEY);
			window.location.reload();
		}
	}, [isWaitingForToken, appJwt]);

	const shouldShowLoader = isWaitingForToken || isWaitingFromStorage;

	if (shouldShowLoader) {
		return <Loader />;
	}

	return (
		<div>
			<LoginOptions headerText="Anmelden" onSubmit={handleLoginOnSubmit} isLoading={false} />
		</div>
	);
};
